import { Dropdown } from 'antd';
import { useIntl } from 'react-intl';
import { FiMoreVertical } from 'react-icons/fi';
import Icon from '@nxsys/components/AppIconImage';
import { IconSidebarToggle } from '@nxsys/assets/icons';
import AppLanguageSwitcher from '../../AppLanguageSwitcher';
import AppHeaderMessages from '../../AppHeaderMessages';
import AppNotifications from '../../AppNotifications';
import UserInfo from '../components/UserInfo';
import SystemSwitcher from '../components/SystemSwitcher';
import {
  StyledAppStandardHeader,
  StyledStandardHeaderSecDesktop,
  StyledStandardHeaderSecMobile,
  StyledStandardSearch,
} from './index.styled';
import { StyledDropdownWrapper } from '../index.styled';
// import { allowMultiLanguage } from '../../../constants/AppConst';
import AppLogo from '../components/AppLogo';
import AppPayrollCountrySwitcher from '../../AppPayrollCountrySwitcher';
import { Icons } from '@nxsys/types/icons';
import { useSelector } from 'react-redux';
import { AppState } from '@nxsys/store';
import { roles } from '@nxsys/store/constants';
import { useNavigateWithQuery } from '@nxsys/hooks/useNavigateWithQuery';

type AppHeaderProps = {
  onToggleSidebar: (isCollapsed: boolean) => void;
  isCollapsed: boolean;
};

const AppHeader = ({ isCollapsed, onToggleSidebar }: AppHeaderProps) => {
  const { messages } = useIntl();
  const navigate = useNavigateWithQuery();
  const { user, isBureau, alternateSystem } = useSelector(
    (state: AppState) => state.appStore,
  );
  const role = user?.role;
  const showCountrySwitcher =
    role !== roles.supper_admin && role !== roles.employee;

  const items = [
    { key: 1, label: <AppHeaderMessages /> },
    { key: 2, label: <AppNotifications /> },
    { key: 3, label: <AppLanguageSwitcher /> },
    ...(showCountrySwitcher
      ? [{ key: 4, label: <AppPayrollCountrySwitcher /> }]
      : []),
  ];
  // An employer opens settings via its own company; an account with no company
  // yet has nothing to open (the gear would navigate to /companies/undefined),
  // so hide the gear until a company exists.
  const employerCompanyId = user?.companyUserIds?.[0];
  const showSettingsIcon =
    isBureau &&
    (role === roles.admin ||
      (role === roles.employer &&
        user?.isAdminCompanyUser &&
        !!employerCompanyId));

  return (
    <StyledAppStandardHeader>
      <Icon
        src={IconSidebarToggle}
        alt="Menu"
        className="trigger"
        onClick={() => onToggleSidebar(!isCollapsed)}
      />
      <AppLogo />
      <StyledStandardSearch
        placeholder={messages['common.searchHere'] as string}
      />
      {role !== roles.employee && alternateSystem && <SystemSwitcher />}
      <StyledStandardHeaderSecDesktop>
        {role !== roles.supper_admin && role !== roles.employee && (
          <AppPayrollCountrySwitcher />
        )}
        {/* {allowMultiLanguage && <AppLanguageSwitcher />} */}
        {showSettingsIcon && (
          <div
            style={{
              marginRight: 5,
              marginLeft: 5,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
            onClick={() =>
              role === roles.admin
                ? navigate('/settings')
                : navigate(`/companies/${employerCompanyId}`)
            }
          >
            <Icons.IconSetting width={22} height={22} />
          </div>
        )}
        <AppNotifications />
        <AppHeaderMessages />
      </StyledStandardHeaderSecDesktop>
      <UserInfo />
      <StyledStandardHeaderSecMobile>
        <StyledDropdownWrapper>
          <Dropdown
            menu={{ items }}
            overlayClassName="dropdown-wrapper"
            getPopupContainer={(triggerNode) => triggerNode}
            trigger={['click']}
          >
            <a
              className="ant-dropdown-link-mobile"
              onClick={(e) => e.preventDefault()}
            >
              <FiMoreVertical />
            </a>
          </Dropdown>
        </StyledDropdownWrapper>
      </StyledStandardHeaderSecMobile>
    </StyledAppStandardHeader>
  );
};

export default AppHeader;
